<div class="submit-request-container">
  <!-- Header -->
  <div class="submit-request-header">
    <div class="header-left">
      <button nz-button nzType="text" nzShape="circle" (click)="onBack()">
        <i nz-icon nzType="arrow-left"></i>
      </button>
      <span>Submit request</span>
    </div>
    <div class="header-right">
      <button nz-button nzType="text" (click)="onCancel()">
        <span>Cancel</span>
      </button>
    </div>
  </div>

  <!-- Step 1: Select Application Type -->
  <div *ngIf="!selectedApplicationTypeId" class="step-container">
    <div class="step-label">Select application type</div>
    <div *ngFor="let type of applicationTypes" class="step-item">
      <button nz-button nzType="text" class="step-button" (click)="onChooseType(type)">
        <span>{{ type.name }}</span>
        <i nz-icon nzType="right"></i>
      </button>
    </div>
  </div>

  <!-- Step 2: Select Application -->
  <div *ngIf="selectedApplicationTypeId && !selectedApplicationId" class="modal-body">
    <div class="description-section">
      <div class="step-label">Select application</div>
      <div *ngFor="let application of applications">
        <div class="step-item">
          <button nz-button nzType="text" class="step-button application-button" (click)="onChooseApplication(application)">
            <div class="application-info">
              <span class="text-grey fw-500">REG - {{ application?.applicationId }}</span><br />
              <span class="text-primary">{{ getCompanyTypeText(application?.opfCode) }}</span><br />
              <span class="text-secondary">{{ application?.nameOfCompany?.nameEn }}</span>
            </div>
            <i nz-icon nzType="right"></i>
          </button>
        </div>
      </div>
      <div class="sticky-button-wrapper">
        <nz-pagination *ngIf="response && !response.content" [nzPageIndex]="page" [nzTotal]="total" (nzPageIndexChange)="onPageChange($event)"
          [nzPageSizeOptions]="[5,10,15,20,25]" nzShowSizeChanger [nzPageSize]="size" (nzPageSizeChange)="onPageSizeChange($event)"></nz-pagination>

      </div>
    </div>
  </div>

  <!-- Step 3: Describe Request -->
  <div *ngIf="selectedApplicationId" class="modal-body">
    <div class="description-section">
      <div class="step-label">Describe the details</div>

      <div class="input-group">
        <label>Message</label>
        <textarea
          rows="5"
          nz-input
          maxlength="200"
          [(ngModel)]="newMessage.content"
          placeholder="Please tell us more about how we can assist"
        ></textarea>
      </div>

      <div class="file-section">
        <div class="file-label">
          File or screenshot <span class="text-description">(optional)</span>
        </div>

        <div *ngIf="fileList.length" class="file-list">
          <div *ngFor="let file of fileList; let i = index" class="file-item">
            <div class="file-name">
              <span nz-icon nzType="file"></span>
              <a class="file-link" (click)="onPreview(file)">{{ file.name }}</a>
            </div>
            <button nz-button nzType="text" nzShape="circle" class="file-delete" (click)="removeFile(i)">
              <i nz-icon nzType="delete"></i>
            </button>
          </div>
        </div>

        <input
          type="file"
          #fileInput
          (change)="onFileChange($event)"
          [accept]="acceptTypes"
          [multiple]="true"
          hidden
        />
        <button
          nz-button
          nzType="dashed"
          class="file-add-button"
          (click)="fileInput.click()"
          [disabled]="fileList.length >= 5"
        >
          <span nz-icon nzType="plus"></span> Add file
        </button>
      </div>

      <div class="sticky-button-wrapper">
        <button nz-button nzType="primary" class="submit-button" (click)="onSendMessage()" [nzLoading]="isLoading">
          Submit request
        </button>
      </div>
    </div>
  </div>
</div>
